/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconBook extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "BookIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><g><polyline points="44.39 3.71 8.76 11.19 14.78 60.29 50.41 52.81 44.39 3.71" fill="#b4b4b4"></polyline><polygon points="55.24 58.43 14.78 60.29 8.76 11.19 49.22 9.33 55.24 58.43" fill="#eae2e6"></polygon><path d="M32,37.65a1.62,1.62,0,0,1-1.78-1.2l-.58-1.94a1.45,1.45,0,0,1,1.09-1.94c2.49-.69,3.54-1.64,3.34-3.07v-.06c-.19-1.31-1.29-1.93-3-1.68a5.47,5.47,0,0,0-3.21,1.66,2.26,2.26,0,0,1-1.25.66,2.09,2.09,0,0,1-2.34-1.75,2.06,2.06,0,0,1,.53-1.69,9.24,9.24,0,0,1,5.76-3c4.2-.61,7.37,1.14,7.93,5v.06c.54,3.7-1.81,5.59-4.9,6.69V36a1.65,1.65,0,0,1-1.37,1.66Zm.28,1.92a2.48,2.48,0,0,1,2.9,2.11v.06a2.56,2.56,0,0,1-5.07.73v-.06A2.48,2.48,0,0,1,32.28,39.57Z" fill="#616161"></path><rect width="64" height="64" fill="none"></rect></g></svg>
    `;
}
